import {Component, inject, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {HeaderComponent} from './shared/components/header/header.component';
import {FooterComponent} from './shared/components/footer/footer.component';
import {LoadingService} from './shared/services/loading.service';
import {LoaderComponent} from './shared/components/loader/loader.component';
import {AlertMessageComponent} from './shared/components/alert-message/alert-message.component';
import {AlertService} from './shared/services/alert.service';
import {ThemeService} from './shared/services/theme.service';
import {AuthService} from './core/auth/auth.service';

@Component({
  selector: 'app-root-web',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    AlertMessageComponent,
  ],
  templateUrl: './app.web.component.html',
  styleUrl: './app.web.component.scss',
  encapsulation: ViewEncapsulation.None // Changed from ShadowDom to None
})
export class AppWebComponent implements OnInit {
  theme: string = 'light'; // Default to light theme for web component
  @Input() private token: string | null = null;
  protected themeService: ThemeService = inject(ThemeService);
  protected loadingService: LoadingService = inject(LoadingService);
  protected alertService: AlertService = inject(AlertService);
  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);

  ngOnInit() {
    // Force light theme for web component context
    if (this.token) {
      this.handleToken(this.token);
    }
    this.themeService.setTheme('light');
    this.theme = 'light';

    this.themeService.themeChanged.subscribe(newTheme => {
      this.theme = newTheme;
    });
    this.router.navigate(["/home"]);
  }

  private handleToken(token: string) {
    this.authService.makeLoginByToken(token).subscribe(() => {
      this.authService.completeLogin(token).subscribe();
    });
  }
}






